import { z } from "zod";
import { emailSchema } from "./commonSchemas";

export const loginSchema = z.object({
  email: emailSchema,

  password: z
    .string()
    .min(1, "validation.passwordRequired")
    .min(6, "validation.passwordMinLength"),
});

export type LoginInput = z.infer<typeof loginSchema>;
